import { smallStore } from 'stores/smallStore/smallStore'
import { subscribeToWindowSize } from 'utils/subscribeToWindowSize'
import { areSafeAreaInsetsEqual } from './areSafeAreaInsetsEqual'
import { createEnvSafeAreaInsetsProbe } from './createEnvSafeAreaInsetsProbe'

export const followEnvSafeAreaInsets = () => {
  const probe = createEnvSafeAreaInsetsProbe()

  const refresh = () => {
    const insets = probe.read()

    if (areSafeAreaInsetsEqual(smallStore.getState().safeArea.insets, insets)) return

    smallStore.setState((s) => ({ ...s, safeArea: { insets } }))
  }

  refresh()

  const unsubscribe = subscribeToWindowSize(refresh)

  return {
    refresh,
    stop: () => {
      unsubscribe()

      probe.remove()
    },
  }
}
